import { useEffect, useState } from "react";
import { User } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { PageHero, Reveal, EmptyState } from "@/components/public/Shared";

export default function Leadership() {
  const [leaders, setLeaders] = useState(null);

  useEffect(() => {
    api.get("/public/leadership").then((r) => setLeaders(r.data)).catch(() => setLeaders([]));
  }, []);

  return (
    <div data-testid="leadership-page">
      <PageHero
        title="Church Leadership"
        subtitle="The servants God has called to shepherd and guide our congregation."
      />
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24">
        {leaders && leaders.length === 0 && (
          <EmptyState
            testId="leadership-empty"
            title="Leadership details coming soon"
            text="Information about our pastor, presbyters and church leadership will be published here once finalised."
          />
        )}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {(leaders || []).map((l, i) => (
            <Reveal key={l.id} delay={i * 0.08}>
              <article className="h-full rounded-lg border border-border bg-white p-8 text-center shadow-sm transition-transform duration-300 hover:-translate-y-1" data-testid={`leader-card-${l.id}`}>
                {l.photo_url ? (
                  <img src={fileUrl(l.photo_url)} alt={l.name} className="mx-auto h-28 w-28 rounded-full object-cover ring-2 ring-gold/40" loading="lazy" />
                ) : (
                  <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full bg-secondary text-navy/40">
                    <User className="h-10 w-10" />
                  </div>
                )}
                <h3 className="mt-5 font-heading text-xl font-bold text-navy">{l.name}</h3>
                <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-gold-dark">{l.position}</p>
                {l.bio && <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{l.bio}</p>}
                {l.contact && <p className="mt-4 text-xs text-muted-foreground">{l.contact}</p>}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
